module.exports = __webpack_public_path__ + "static/media/ic_clock.95cf6456.svg";